// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1knUS","placeholdersHeader":"styles_placeholdersHeader__2rmww","editorStyle":"styles_editorStyle__XSRXF","placeholdersBox":"styles_placeholdersBox__2lusq"};